import { Col, Row } from 'antd';
import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { LinkButton } from 'components/atoms/button';
import { GoalModal } from './goal-modal';

export const Title: FC<{ projectId: number }> = ({ projectId }) => {
  const [visible, setVisible] = useState(false);
  const onClose = () => setVisible(false);

  return (
    <Row>
      <Col flex={1}>
        <strong>
          <FormattedMessage id="project.overview.business_goals.title" />
        </strong>
      </Col>
      <LinkButton onClick={() => setVisible(true)}>
        <FormattedMessage id="project.overview.business_goals.title.cta" />
      </LinkButton>
      <GoalModal projectId={projectId} visible={visible} onClose={onClose} />
    </Row>
  );
};
